export default __webpack_public_path__ + "b2831770314af46cfc574b0c58f594af.png";